(function() {
  'use strict';

  function GoalController(
    $q,
    $rootScope,
    $scope,
    $translate,
    Goal,
    Router,
    Profile,
    List,
    Utils,
    Users,
    Network,
    Notify,
    GOALS_STATES,
    LocalizationService
  ) {
    var ctrl = this;

    ctrl.GOALS_STATES = GOALS_STATES;

    function selectPeriod(periodId) {
      ctrl.goal.setPeriod(periodId);
    }

    function hasPerm(action) {
      var permission;

      if (action === 'view') {
        permission = 'canViewAny';
      } else if (action === 'work') {
        permission = 'canWork';
      }

      if (!permission) {
        return $q.reject({ status: 403 });
      }

      return ctrl.goal.checkPermission(permission);
    }

    function buildEventHref() {
      var route;
      if (!ctrl.goal.isMine()) {
        route = ['/users/edit', ctrl.goal.event.doc.user, 'events', ctrl.goal.event.doc._id];
      } else {
        route = ['/events/view', ctrl.goal.event.doc._id];
      }

      ctrl.eventRoute = route;
    }

    var updateVisibility = function(event, changeTo) {
      Utils.swal({
        title: 'This will change the visibility of the event and ' +
                'all the goals. Do you wish to continue?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK'
      },
      function(isConfirm) {
        if (isConfirm) {
          if (changeTo === 'private') {
            event.makePrivate();
          } else if (changeTo === 'public') {
            event.makePublic();
          }
        }
      });
    };

    ctrl.markGoal = function() {
      Network.forceOnline({ showToastr: true })
        .then(function() {
          return ctrl.goal.openResolveDataModal();
        })
        .then(function() {
          ctrl.goal.reloadState();
        });
    };

    ctrl.auditLogId = Utils.guid();

    function loadButtons() {
      ctrl.actionButtons = [
        {
          id: 'showDescription',
          icon: 'icon-history',
          label: ctrl.shownDescription ? 'Hide audit log' : 'Show audit log',
          klass: 'text-info',
          onClick: function() {
            ctrl.shownDescription = !ctrl.shownDescription;
            this.label = ctrl.shownDescription ? 'Hide audit log' : 'Show audit log';
            this.attrs['aria-expanded'] = ctrl.shownDescription ? 'true' : 'false';
          },
          showCondition: function() {
            return !_.isUndefined(ctrl.goal.doc.dates);
          },
          attrs: {
            'aria-expanded': ctrl.shownDescription,
            'aria-controls': ctrl.auditLogId
          }
        }
      ];

      ctrl.actionButtons.push.apply(
        ctrl.actionButtons,
        [
          {
            label: $translate.instant('Reload'),
            icon: 'icon-reload',
            onClick: function() {
              ctrl.loadGoal()
                .then(function() {
                  Notify.success('Goal reloaded');
                })
                .catch(function(err) {
                  console.log(err);
                  Notify.error('Reloading of goal failed');
                });
            },
            klass: 'text-info',
            showCondition: ctrl.goal.checkPermission.bind(ctrl.goal, 'canEdit')
          },
          {
            label: $translate.instant('Edit'),
            icon: 'icon-edit',
            route: (function() {
              var route;
              if (ctrl.goal.isMine()) {
                route = ['/goals/edit-definition', ctrl.goal.doc._id];
              } else {
                route = ['/users/edit-definition', ctrl.goal.doc.user, 'goals', ctrl.goal.doc._id];
              }

              return route;
            })(),
            klass: 'text-info',
            showCondition: ctrl.goal.checkPermission.bind(ctrl.goal, 'canEdit')
          },
          {
            label: $translate.instant('Delete'),
            icon: 'icon-trash',
            onClick: function() {
              Network.forceOnline({ showToastr: true })
                .then(function() {
                  return ctrl.goal.remove();
                })
                .then(function() {
                  if (ctrl.goal.isMine()) {
                    Router.navigate(['/goals/list']);
                  } else {
                    Router.navigate(['/users/edit', ctrl.goal.doc.user, 'goals']);
                  }
                });
            },
            klass: 'text-danger',
            showCondition: ctrl.goal.checkPermission.bind(ctrl.goal, 'canRemove')
          }
        ]
      );

      if (!_.isEmpty(ctrl.goal.event)) {
        ctrl.actionButtons.push.apply(
          ctrl.actionButtons,
          [
            {
              label: $translate.instant('Share'),
              icon: 'icon-lock-open',
              onClick: function() {
                updateVisibility(ctrl.goal.event, 'public');
              },
              klass: 'text-info',
              showCondition: ctrl.goal.event.checkPermission.bind(
                ctrl.goal.event,
                'canMakePublic'
              )
            },
            {
              label: $translate.instant('Make private'),
              icon: 'icon-lock',
              onClick: function() {
                updateVisibility(ctrl.goal.event, 'private');
              },
              klass: 'text-danger',
              showCondition: ctrl.goal.event.checkPermission.bind(
                ctrl.goal.event,
                'canMakePrivate'
              )
            }
          ]
        );
      }
    }
    var load;

    var loadWatched = function() {
      $rootScope.$on('goalProgressUpdated', function() {
        load().then(function() {
          return ctrl.goal.setPeriod();
        });
      });

      // used to change visibility
      $scope.$on('DBPullChange', function(_evt, args) {
        if (!_.isEmpty(ctrl.goal.event) && args.id === ctrl.goal.event.doc._id) {
          load();
        }
      });
    };
    var prefs = Profile.getPreferences();
    load = function() {
      ctrl.goal = null;
      return Goal.find(ctrl.goalId, Users.remoteUser, { loadGoalSetSummary: true })
        .then(function(goal) {
          if (!goal) {
            Router.navigate(['/goals']);
            return $q.reject();
          }

          ctrl.goal = goal;
          Utils.setPageTitle('Goals: ' + ctrl.goal.doc.title);
          prefs.goalDoc = ctrl.goal.doc;
          var periodId = goal.getCurrentPeriodId();
          selectPeriod(periodId);

          return goal;
        })
        .then(function(goal) {
          // in case the event has been deleted, let the opportunity to the owner to delete it.
          if (_.isUndefined(goal.event.eventType) && goal.isMine()) {
            return $q.when(true);
          }
          return hasPerm(ctrl.action);
        })
        .then(function() {
          if (!_.isEmpty(ctrl.goal.event)) {
            buildEventHref();
          } else {
            ctrl.noEvent = true;
          }

          loadButtons();
          return $q.when();
        })
        .then(function() {
          ctrl.isSetClosed = ctrl.goal.isSetClosed();
          var canMark = ctrl.goal.checkPermission('canMark')
            .catch(function() { return $q.when(false); });

          return $q.all([ctrl.goal.isMarkStepEnabled(), canMark])
            .then(function(result) {
              ctrl.isMarkStepEnabled = result[0];
              ctrl.canMark = result[1];
            });
        })
        .then(function() {
          loadWatched();
        });
    };
    ctrl.$onChanges = function() {
      ctrl.dateFormat = LocalizationService.getDateTimeFormat('dateonly');

      ctrl.options = {};

      ctrl.list = new List({ idField: '_id' });
      ctrl.options = { trackBy: '_id' };

      load()
      .catch(function(error) {
        if (error && error.status === 404) {
          Router.navigate(['/goals']);
          return;
        }

        // Utils.showError(error);
        Router.navigate(['/goals']);
      });
      ctrl.loadGoal = load;
    };


    $scope.$on('GoalPeriodSelected', function(_evt, periodFilter) {
      var splitted = periodFilter.split('|'),
          periodId = splitted[1];
      selectPeriod(periodId);
    });

    $scope.$on('$destroy', function() {
      prefs.goalDoc = undefined;
    });
  }

  GoalController.$inject = [
    '$q',
    '$rootScope',
    '$scope',
    '$translate',
    'GoalFactory',
    'Router',
    'ProfileService',
    'ListFactory',
    'UtilsService',
    'UsersService',
    'NetworkService',
    'NotifyService',
    'GOALS_STATES',
    'LocalizationService'


  ];

  angular.module('component.goals')
    .component('goalComponent', {
      controller: GoalController,
      controllerAs: 'goalCtrl',
      templateUrl: 'app/components/goals/goal.html',
      bindings: {
        goalId: '<',
        user: '<',
        periodId: '<'
      }
    });
})();
